import { getJSON, postJSON, getJSONP } from './myaxios';

export function get_user_info_api(ticket) {
  const params = {
    ticket: ticket,
    invoker: 'aaa',
    t: new Date().getTime()
  };
  return getJSONP(gact.config.api_user_info, params);
}

export function get_vip_info(ticket) {
  const params = {
    ticket: ticket,
    uuid: window.$bus.user.uuid,
    version: window.$bus.device_info.appVersion,
    os: window.$bus.device_info.osType,
    os_type: window.$bus.device_info.osType,
    mac: window.$bus.device_info.did,
    t: new Date().getTime(),
    invoker: window.gact.invoker,
    ip: '127.0.0.2'
  }
  return getJSON(gact.config.api_vip_info, params)
}

export function get_user_info(ticket) {
  // TODO（svip 临时方案）
  return new Promise((resolve) => {
    let api_result;
    let vip_info_result;
    const check_callback = () => {
      if (api_result && vip_info_result) {
        api_result.data = {
          ...api_result.data,
          ...vip_info_result,
        }
        resolve(api_result);
      }
    }
    get_user_info_api(ticket).then((res) => {
      if (res && res.ret === 0 && res.data) {
        api_result = res;
      } else {
        api_result = {
          data: {},
        };
      }
      check_callback();
    });
    get_vip_info(ticket).then((res) => {
      if (res && res.status === "200" && res.data) {
        const { is_mpp_svip, mpp_svip_end_date } = res.data;
        vip_info_result = {
          is_mpp_svip,
          mpp_svip_end_date,
        };
      } else {
        vip_info_result = {};
      }
      check_callback();
    });
  });
}

export function get_act_stat() {
  const params = {
    act_name: window.rootdata.act_name,
    invoker: window.gact.invoker
  };
  if (gact.f_release) {
    params.f_release = gact.f_release;
  }
  return getJSON('//vipact3.api.mgtv.com/api/v1/ch/info', params, 10000, false, true);
}

//让ticket主动失效
export function api_logout() {
  if (window.$bus.user.ticket) {
    return;
  }
  const param = {
    ticket: window.$bus.user.ticket,
    invoker: 'aaa'
  };
  return getJSONP(gact.config.api_logout, param)
    .then(res => {
      console.log('主动退出', res);
      if (res && res.code === 200) {
        console.log('主动退出成功');
      } else {
        console.error('主动退出失败');
      }
    })
    .catch(e => {
      console.error('主动退出异常', e.message);
    });
}

export function get_dynamic_entry(entry_source) {
  const params = {
    uuid: window.$bus.user.uuid,
    version: window.$bus.device_info.appVersion,
    invoker: gact.invoker,
    mac: window.$bus.device_info.did,
    source: entry_source,
    _support: 100001,
    src: 'mgtv',
    abroad: 0,
    act_name: window.rootdata.act_name
  };
  return getJSONP('//vip.bz.mgtv.com/client/dynamic_entry', params, 10000);
}

/**
 * 用户人群检测接口
 * https://wiki.imgo.tv/pages/viewpage.action?pageId=3736132#id-%E4%BC%9A%E5%91%98%E8%AE%A1%E8%B4%B9%E7%B3%BB%E7%BB%9FAS%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3%EF%BC%88forclient%EF%BC%89-7.%E7%94%A8%E6%88%B7%E4%BA%BA%E7%BE%A4%E6%A3%80%E6%B5%8B%E6%8E%A5%E5%8F%A3
 * @param {Array} ids
 */
export function user_groups_check(ids = []) {
  const params = {
    uuid: window.$bus.user.uuid,
    version: window.$bus.device_info.appVersion,
    ticket: window.$bus.user.ticket,
    invoker: gact.invoker,
    t: Date.now(),
    mac: window.$bus.device_info.did,
    user_group_ids: ids.join(',')
  };
  return getJSONP(gact.config.api_user_groups_check, params);
}

/**
 *
 * @param {奖品信息} item
 * @param {模块ID} act_name
 * @returns
 */
export function getAward(item, act_name,tel='') {
  return getJSON('//vipact3.api.mgtv.com/api/v1/app/vip/benefits/award/recv', {
    act_name,
    award_id: item.award_id,
    ticket: window.$bus.user.ticket,
    tel
  });
}

/**
 *
 * @param {模块ID} act_name
 * @param {奖品信息} award_info
 * @returns
 */
export function getYuyueInfo(act_name, award_info) {
  const params = {
    ticket: window.$bus.user.ticket,
    act_name,
    phase: award_info.record_id, //约定
    t: new Date().getTime()
  };
  return getJSON(`//vipact3.api.mgtv.com/api/v1/act/uinfo/get`, params);
}

/**
 *
 * @param {奖品信息} award_id
 * @param {模块ID} act_name,
 * @returns
 */
export function getAwardRecv(act_name,award_id) {
  const params = {
    ticket: window.$bus.user.ticket,
    award_id,
    act_name,
    t: new Date().getTime()
  };
  return getJSON(`//vipact3.api.mgtv.com/api/v1/app/vip/benefits/has/recv`, params);
}



export function appointment({ submit_info, act_name, comp_id, phase }) {
  const param = {
    ticket: window.$bus.user.ticket,
    act_name,
    comp_id,
    phase
  };
  //这个接口后端做的比较奇怪，如果没有提交信息，post中的info字段不能为空，只能 [{}]这么写了。
  return postJSON(`//vipact3.api.mgtv.com/api/v1/act/uinfo/add`, param, { info: submit_info });
}

export function getFzsToken(appId) {
  return getJSON('https://viputil.api.mgtv.com/util/v1/server/mg/apply', {
    ticket: window.$bus.user.ticket,
    appId, // 蜂助手特定ID
  });
}

/**
 * 静默绑定企业微信信息
 * @param {企微外部联系人用户external_user_id， 推送欢迎语或营销聊天信息会自动拼接到落地页url参数} eid
 * @returns
 */
export function bindQiyeWx(eid) {
    const param = {
      ticket: window.$bus.user.ticket,
      eid
    };
    getJSON(`//vipact3.api.mgtv.com/api/v1/app/wx/work/bind/uuid`, param);
}

export function get_act_load_file() {
  const params = {
    act_name: window.rootdata.act_name,
    invoker: window.gact.invoker
  };
  if (gact.f_release) {
    // params.f_release = gact.f_release;
  }
  return getJSON('//vipact3.api.mgtv.com/api/v1/app/ch/load/file', params, 10000, false, true);
}
